import apiInstance from '../utils/axiosConfig';

const ClientService = {
    // ==============================================
    // CRÉATION
    // ==============================================

    // Créer un client SANS fichiers (JSON pur)
    createClient: async (clientRequestDTO) => {
        try {
            const response = await apiInstance.post(
                '/clients/createClient',
                clientRequestDTO,
                { headers: { 'Content-Type': 'application/json' } }
            );
            return response.data;
        } catch (error) {
            console.error('Error creating client (JSON):', error.message || error);
            throw error;
        }
    },

    // Créer un client AVEC fichiers (multipart/form-data)
    createClientWithFiles: async (clientData, profilePhoto = null, identityDocument = null) => {
        try {
            const formData = new FormData();
            // Sérialisation du JSON en string (le backend utilise objectMapper.readValue)
            formData.append('clientData', JSON.stringify(clientData));
            if (profilePhoto) formData.append('profilePhoto', profilePhoto);
            if (identityDocument) formData.append('identityDocument', identityDocument);

            const response = await apiInstance.post(
                '/clients/createClient',
                formData,
                {
                    headers: {
                        // Laisser le navigateur définir le boundary automatiquement
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error creating client (with files):', error.message || error);
            throw error;
        }
    },

    // ==============================================
    // RÉCUPÉRATION
    // ==============================================

    // Récupérer un client par ID
    getClientById: async (id) => {
        try {
            const response = await apiInstance.get(`/clients/getClientById/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching client by id:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les clients
    getAllClients: async () => {
        try {
            const response = await apiInstance.get('/clients/getAllClients');
            return response.data;
        } catch (error) {
            console.error('Error fetching all clients:', error.message || error);
            throw error;
        }
    },

    // ==============================================
    // MISE À JOUR
    // ==============================================

    // Mettre à jour un client SANS fichiers (JSON pur)
    updateClient: async (id, clientRequestDTO) => {
        try {
            const response = await apiInstance.put(
                `/clients/updateClient/${id}`,
                clientRequestDTO,
                { headers: { 'Content-Type': 'application/json' } }
            );
            return response.data;
        } catch (error) {
            console.error('Error updating client (JSON):', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un client AVEC fichiers (multipart/form-data)
    updateClientWithFiles: async (id, clientData, profilePhoto = null, identityDocument = null) => {
        try {
            const formData = new FormData();
            formData.append('clientData', JSON.stringify(clientData));
            if (profilePhoto) formData.append('profilePhoto', profilePhoto);
            if (identityDocument) formData.append('identityDocument', identityDocument);

            const response = await apiInstance.put(
                `/clients/updateClientWithFiles/${id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error updating client (with files):', error.message || error);
            throw error;
        }
    },

    // ==============================================
    // SUPPRESSION (SOFT DELETE)
    // ==============================================

    deleteClient: async (id) => {
        try {
            await apiInstance.delete(`/clients/deleteClient/${id}`);
        } catch (error) {
            console.error('Error deleting client:', error.message || error);
            throw error;
        }
    },
};

export default ClientService;